import styled from 'styled-components';

interface ITableDataProps {
  width?: string;
  textAlign?: string;
  textColor?: string|null;
  bold?: boolean;
  borderStyle?: string;
  backgroundColor?: string;
  padding?: string;
}

export const TableData = styled.td<ITableDataProps>`
  width: ${props => props.width || 'auto'};
  max-width: ${props => props.width || 'auto'};
  text-align: ${props => props.textAlign || 'auto'};
  color: ${props => props.textColor || '#74777a'}!important;
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  border: ${props => props.borderStyle || 'auto'}!important;
  background-color: ${props => props.backgroundColor || 'auto'}!important;
  padding: ${props => props.padding || 'auto'}!important;
`;